import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Divider, LoadingOverlay, Tabs } from '@mantine/core';
import { IconSettings, IconPilcrow, IconCheckbox } from '@tabler/icons';
import { ContractContext } from '../../Service/Context/ContractContextV2';
import DocumentAgreements from '../../Molecules/Document/DocumentAgreements';
import DocumentHead from '../DocumentHead';
import ContractLayoutSection from './sections/ContractLayoutSection';
import ContractSignatureSection from './sections/ContractSignatureSection';
import ContractGeneralSection from './sections/ContractGeneralSection';
import EventContractHeaderActions from './EventContractHeadActions';
import ContractContentSection from './sections/ContractContentSection';
import ContractPdfSection from './sections/ContractPdfSection';

const Contract = () => {
  const { id: eventId } = useParams();
  const { loading, contract } = useContext(ContractContext);
  const { id, number } = contract ?? {};

  return (
    <Container p={0} pos="relative">
      <LoadingOverlay visible={loading} overlayBlur={2} loaderProps={{ size: 'xl' }} />
      {contract && (
        <DocumentHead
          entityType="contracts"
          entityId={contract.id.toString()}
          title={`Vertrag ${number}`}
          previewUrl={`/events/${eventId}/contracts/${id}/preview`}
          documentActions={<EventContractHeaderActions />}
        />
      )}
      <Divider my="xs" />
      <Tabs
        styles={{
          tab: {
            '&[data-active]': {
              fontWeight: 'bolder',
            },
          },
        }}
        defaultValue="content"
      >
        <Tabs.List>
          <Tabs.Tab value="content" icon={<IconPilcrow size={14} />}>
            Inhalt
          </Tabs.Tab>
          <Tabs.Tab value="settings" icon={<IconSettings size={14} />}>
            Einstellungen
          </Tabs.Tab>
          {/* <Tabs.Tab value="agreements" icon={<IconCheckbox size={14} />}>
            Vereinbarungen
          </Tabs.Tab> */}
        </Tabs.List>
        <Tabs.Panel value="content" pt="xl">
          <ContractGeneralSection />
          <Divider my={30} />
          <ContractContentSection />
        </Tabs.Panel>
        <Tabs.Panel value="settings" pt="xs">
          <ContractLayoutSection />
          <Divider my={30} />
          <ContractSignatureSection />
          <Divider my={30} />
          <ContractPdfSection />
        </Tabs.Panel>
        {/* <Tabs.Panel value="agreements" pt="xs">
          {contract && <DocumentAgreements documentId={contract.id} agreements={contract.agreements} />}
        </Tabs.Panel> */}
      </Tabs>
    </Container>
  );
};

export default Contract;
